import React from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, setFormError } from '../../../utils/utils';
import { createTelemetry, editTelemetryById, loadTelemetryList } from '../actions';
import Loader from '../../../components/base/Loader/Loader';
import { getTelemetryData } from '../reducer';
import TelemetryDTO from '../../../dto/TelemetryDTO';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadRulesList } from '../../Rules/actions';
import SelectGeographies from '../../Rules/components/SelectGeographies';
import { loadProviderList } from '../../Provider/actions';

export default function TelemetryForm(props) {
  const {
    onClose = () => {},
    loadData = () => {},
    loadTelemetry = () => {},
    currentTelemetry = null,
  } = props;
  const { loadingCreateTelemetry, loadingEditTelemetryById } = useSelector(getTelemetryData);
  const dispatch = useDispatch();
  const {
    reset, control, getValues, setError,
  } = useForm({
    mode: 'onChange',
    defaultValues: currentTelemetry || {},
  });

  const handleSave = () => {
    const values = getValues();
    const action = currentTelemetry?.id ? editTelemetryById({ ...values, id: currentTelemetry.id }) : createTelemetry(values);
    dispatch(action)
      .then(telemetry => {
        successNotification('Сохранение формы', 'Форма сохранена');
        loadData();
        loadTelemetry(telemetry.id);
        onClose();
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы', getResponseError(response));
      });
  };

  const dto = new TelemetryDTO();
  const attributes = dto.getAttributesByName();

  return ReactDOM.createPortal(
    <div className="form-dialog telemetry-form">
      <Loader loading={loadingCreateTelemetry || loadingEditTelemetryById} />
      <div className="form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Телеметрии</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Телеметрия № {currentTelemetry?.id || 'Без номера'}</span>
          <span className="breadcrumbs-current"> ({currentTelemetry?.id ? 'редактирование' : 'создание'}) </span>

        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="form-body">
        <form className="form-content">
          <div className="form-fields">
            <div className="form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main telemetry-main-info">
                  <Row className="row-cols-1">
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.name}
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.description}
                      variant="material"
                      withLabel
                      className="mb-3"
                      textarea
                    />
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.currency}
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={DateTimePicker}
                      hideTime
                      changeFormat="YYYY-MM-DD"
                      dtoObject={attributes.start_date}
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={DateTimePicker}
                      hideTime
                      changeFormat="YYYY-MM-DD"
                      dtoObject={attributes.end_date}
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={DateTimePicker}
                      hideTime
                      changeFormat="YYYY-MM-DD"
                      dtoObject={attributes.published_date}
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                    {/* <FieldDTOWithCol */}
                    {/*  control={control} */}
                    {/*  type="text" */}
                    {/*  component={CustomSelectInput} */}
                    {/*  dtoObject={attributes.provider_ids} */}
                    {/*  variant="material" */}
                    {/*  withLabel */}
                    {/*  options={PROVIDER_LIST} */}
                    {/*  className="mb-3" */}
                    {/* /> */}
                    <FieldDTOWithCol
                      control={control}
                      dtoObject={attributes.provider_ids}
                      usePortal
                      component={SelectGeographies}
                      portalClassName="executor-selector"
                      loadAction={loadProviderList}
                      optionFormatter={item => ({ value: item.id, name: item.provider_name })}
                      filterName="full_name"
                      variant="material"
                      withLabel
                      className="mb-3"
                      // multiple
                    />
                    <FieldDTOWithCol
                      control={control}
                      dtoObject={attributes.rules}
                      usePortal
                      addPlaceholder
                      component={CustomSelectInputWithHelper}
                      portalClassName="executor-selector"
                      loadAction={loadRulesList}
                      optionFormatter={item => ({ value: item.id, name: item.name })}
                      filterName="full_name"
                      variant="material"
                      withLabel
                      className="mb-3"
                    />
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className="form-footer">
            <Button onClick={() => handleSave()}>{currentTelemetry?.id ? 'Сохранить' : 'Создать'}</Button>
            <Button variant="secondary" onClick={onClose}>Отменить</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
